"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeTagToString = void 0;
var uplc_1 = require("@harmoniclabs/uplc");
function nativeTagToString(nativeTag) {
    if (nativeTag >= 0)
        return (0, uplc_1.builtinTagToString)(nativeTag);
    switch (nativeTag) {
        case -1 /* IRNativeTag.z_comb */: return "z_comb";
        case -2 /* IRNativeTag._matchList */: return "matchList";
        case -3 /* IRNativeTag._recursiveList */: return "recursiveList";
        case -4 /* IRNativeTag._dropList */: return "dropList";
        case -5 /* IRNativeTag._indexList */: return "indexList";
        case -6 /* IRNativeTag._foldr */: return "foldr";
        case -7 /* IRNativeTag._foldl */: return "foldl";
        case -8 /* IRNativeTag._mkFind */: return "mkFind";
        case -9 /* IRNativeTag._length */: return "length";
        case -10 /* IRNativeTag._some */: return "some";
        case -11 /* IRNativeTag._every */: return "every";
        case -12 /* IRNativeTag._mkFilter */: return "mkFilter";
        // case IRNativeTag._fstPair       : return "fstPair";
        // case IRNativeTag._sndPair       : return "sndPair";
        case -15 /* IRNativeTag._id */: return "id";
        case -16 /* IRNativeTag._not */: return "not";
        case -17 /* IRNativeTag._strictAnd */: return "strictAnd";
        case -18 /* IRNativeTag._and */: return "and";
        case -19 /* IRNativeTag._strictOr */: return "strictOr";
        case -20 /* IRNativeTag._or */: return "or";
        case -21 /* IRNativeTag._gtBS */: return "gtBS";
        case -22 /* IRNativeTag._gtEqBS */: return "gtEqBS";
        case -23 /* IRNativeTag._gtInt */: return "gtInt";
        case -24 /* IRNativeTag._gtEqInt */: return "gtEqInt";
        case -25 /* IRNativeTag._strToData */: return "strToData";
        case -26 /* IRNativeTag._pairDataToData */: return "pairToData";
        case -27 /* IRNativeTag._strFromData */: return "strFromData";
        case -28 /* IRNativeTag._pairDataFromData */: return "pairFromData";
        case -29 /* IRNativeTag._lazyChooseList */: return "lazyChooseList";
        default: return "";
    }
}
exports.nativeTagToString = nativeTagToString;
